export default "__VITE_ASSET__XTlwQazl__ 430w";